import { render, staticRenderFns } from "./newLink.vue?vue&type=template&id=77dd8a09&scoped=true"
import script from "./newLink.vue?vue&type=script&lang=js"
export * from "./newLink.vue?vue&type=script&lang=js"
import style0 from "./newLink.vue?vue&type=style&index=0&id=77dd8a09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd8a09",
  null
  
)

export default component.exports